import { SendRounded } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Grid,
    IconButton,
    InputBase,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
} from '@mui/material';
import { ref } from 'firebase/database';
import moment from 'moment';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useDatabaseListData } from 'reactfire';
import { sendMessage } from '../../api/chat';
import { database } from '../../auth/firebase';
import ExternalScreen from '../../components/fragments/ExternalScreen';
import useAuth from '../../hooks/useAuth';
import useSettings from '../../hooks/useSettings';

export default function ChatRouteScreen() {
    const [text, setText] = React.useState('');

    const location = useLocation();
    const params = useParams();
    const { themeMode } = useSettings();
    const { user } = useAuth();

    const { data: messages } = useDatabaseListData(
        ref(database, `chat/messages`)
    );

    const handleSendMesage = () => {
        if (!text || text.length < 1) return;

        sendMessage({
            message: text,
            receiver: params.id,
            sender: user?.username,
        });

        setText('');
    };

    return (
        <ExternalScreen title={`${params.id}`}>
            <Grid item xs={12}>
                <List sx={{ pb: 4 }}>
                    {messages
                        ?.filter(
                            ({ senderUsername, recieverUsername }) =>
                                (senderUsername == user?.username &&
                                    recieverUsername == params.id) ||
                                (senderUsername == params.id &&
                                    recieverUsername == user?.username)
                        )
                        .map(
                            ({
                                id,
                                message,
                                recieverUsername,
                                serverTimestamp,
                            }) => {
                                const you = recieverUsername == params.id;

                                return (
                                    <ListItem
                                        className="align-items-start"
                                        sx={{ p: 0 }}
                                        key={id}
                                    >
                                        {!you && (
                                            <ListItemAvatar>
                                                <Avatar>
                                                    {location.state?.name?.slice(
                                                        0,
                                                        1
                                                    )}
                                                </Avatar>
                                            </ListItemAvatar>
                                        )}

                                        {you && <ListItemText />}
                                        <ListItemText
                                            sx={{
                                                p: 1,
                                                flex: 'none',
                                                borderRadius: 1,
                                                border:
                                                    themeMode == 'light'
                                                        ? `2px solid`
                                                        : 'none',
                                                borderColor: 'primary.main',
                                                bgcolor: you
                                                    ? 'primary.main'
                                                    : 'background.paper',
                                                color: you
                                                    ? 'common.white'
                                                    : 'text.primary',
                                            }}
                                            primary={message}
                                            secondary={`${moment(
                                                serverTimestamp
                                            ).format('MMM DD HH:mm')}`}
                                        />
                                    </ListItem>
                                );
                            }
                        )}
                </List>
            </Grid>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: window.innerWidth,
                    p: 1,
                }}
            >
                <Paper
                    className="d-flex align-items-center"
                    sx={{ py: 0.5, pl: 2, pr: 1 }}
                    elevation={4}
                >
                    <InputBase
                        value={text}
                        fullWidth
                        placeholder="Message"
                        onChange={(e) => setText(e.target.value)}
                    />
                    <IconButton onClick={handleSendMesage}>
                        <SendRounded />
                    </IconButton>
                </Paper>
            </Box>
        </ExternalScreen>
    );
}
